module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.cb272fc5.png";